import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="-7 -9 24 24">
      <path d="M0 6L0.833333 5H9.16667L10 6H0Z"/>
      <path d="M2.5 3L1.66667 4H8.33333L7.5 3H2.5Z"/>
      <path d="M3.33333 2L5 0L6.66667 2H3.33333Z"/>
    </SvgIcon>
  );
}